import { useState } from "react";

export interface FaqItem {
  question: string;
  answer: string;
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const isOpen = open === index;
        return (
          <div key={item.question}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : index)}
              className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
              aria-expanded={isOpen}
            >
              <span className="flex items-start gap-3">
                <span className="mt-0.5 font-heading text-sm font-bold text-primary-600">
                  Q{index + 1}
                </span>
                <span className="font-medium text-foreground-950">{item.question}</span>
              </span>
              <i
                className={`shrink-0 text-xl text-foreground-500 transition-transform ${
                  isOpen ? "ri-subtract-line" : "ri-add-line"
                }`}
              />
            </button>
            {isOpen && (
              <div className="px-5 pb-5 pl-[3.4rem]">
                <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}